export enum SearchType {
  LIST = 'list',
  MAP = 'map',
}
